import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

interface ErrorModalSliceState {
  isOpen: boolean;
  msg?: string | undefined;
  status?: string | undefined;
}

const initialState: ErrorModalSliceState = { isOpen: false };

export const ErrorModalSlice = createSlice({
  name: 'errorModal',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    showErrorModal: (
      state,
      action: PayloadAction<{ msg: string; status?: string }>
    ) => {
      state.isOpen = true;
      state.msg = action.payload.msg;
      state.status = action.payload.status;
    },
    closeErrorModal: (state) => {
      // state.id = action.payload.id;
      state.isOpen = false;
      state.msg = undefined;
      state.status = undefined;
    }
  }
});

export const { showErrorModal, closeErrorModal } = ErrorModalSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const getErrorModal = (state: RootState) => state.errorModal;

export default ErrorModalSlice.reducer;
